import Vue from "vue";
import VueRouter from "vue-router";
import routesAgenda from "@/router/Agenda/router";
import routesAgendamentoOnline from "@/router/AgendamentoOnline/router";

Vue.use(VueRouter);
let routes = process.env.VUE_APP_EH_AGENDAMENTO_ONLINE == "1" ? routesAgendamentoOnline : routesAgenda;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
